/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardCreatePartnerGroup,
  DashboardPartnerGroup,
  DashboardPartnerGroupsControllerCreate400,
  DashboardPartnerGroupsControllerCreate401,
  DashboardPartnerGroupsControllerCreate429,
  DashboardPartnerGroupsControllerDetail400,
  DashboardPartnerGroupsControllerDetail401,
  DashboardPartnerGroupsControllerDetail404,
  DashboardPartnerGroupsControllerDetail429,
  DashboardPartnerGroupsControllerList400,
  DashboardPartnerGroupsControllerList401,
  DashboardPartnerGroupsControllerList429,
  DashboardPartnerGroupsControllerListParams,
  DashboardPartnerGroupsControllerRemove400,
  DashboardPartnerGroupsControllerRemove401,
  DashboardPartnerGroupsControllerRemove404,
  DashboardPartnerGroupsControllerRemove429,
  DashboardPartnerGroupsControllerRemoveParams,
  DashboardPartnerGroupsControllerUpdate400,
  DashboardPartnerGroupsControllerUpdate401,
  DashboardPartnerGroupsControllerUpdate404,
  DashboardPartnerGroupsControllerUpdate429,
  DashboardUpdatePartnerGroup,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Partner groups for a single owner scope, ordered by title. Supply exactly one owner filter — `platformIds` (`plt_…`) OR `federationIds` (`fed_…`) OR `leagueIds` (`lge_…`), each with a single public id. Each row carries `partnersCount`. Not paginated.
 * @summary List partner groups (dashboard)
 */
export const dashboardPartnerGroupsControllerList = (
  params?: DashboardPartnerGroupsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPartnerGroup[]>(
    { url: `/api/dashboard/v1/partner-groups`, method: "GET", params, signal },
    options
  );
};

export const getDashboardPartnerGroupsControllerListQueryKey = (
  params?: DashboardPartnerGroupsControllerListParams
) => {
  return [`/api/dashboard/v1/partner-groups`, ...(params ? [params] : [])] as const;
};

export const getDashboardPartnerGroupsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
  TError = ErrorType<
    | DashboardPartnerGroupsControllerList400
    | DashboardPartnerGroupsControllerList401
    | DashboardPartnerGroupsControllerList429
  >,
>(
  params?: DashboardPartnerGroupsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardPartnerGroupsControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>
  > = ({ signal }) => dashboardPartnerGroupsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPartnerGroupsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>
>;
export type DashboardPartnerGroupsControllerListQueryError = ErrorType<
  | DashboardPartnerGroupsControllerList400
  | DashboardPartnerGroupsControllerList401
  | DashboardPartnerGroupsControllerList429
>;

export function useDashboardPartnerGroupsControllerList<
  TData = Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
  TError = ErrorType<
    | DashboardPartnerGroupsControllerList400
    | DashboardPartnerGroupsControllerList401
    | DashboardPartnerGroupsControllerList429
  >,
>(
  params: undefined | DashboardPartnerGroupsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPartnerGroupsControllerList<
  TData = Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
  TError = ErrorType<
    | DashboardPartnerGroupsControllerList400
    | DashboardPartnerGroupsControllerList401
    | DashboardPartnerGroupsControllerList429
  >,
>(
  params?: DashboardPartnerGroupsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPartnerGroupsControllerList<
  TData = Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
  TError = ErrorType<
    | DashboardPartnerGroupsControllerList400
    | DashboardPartnerGroupsControllerList401
    | DashboardPartnerGroupsControllerList429
  >,
>(
  params?: DashboardPartnerGroupsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List partner groups (dashboard)
 */

export function useDashboardPartnerGroupsControllerList<
  TData = Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
  TError = ErrorType<
    | DashboardPartnerGroupsControllerList400
    | DashboardPartnerGroupsControllerList401
    | DashboardPartnerGroupsControllerList429
  >,
>(
  params?: DashboardPartnerGroupsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPartnerGroupsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPartnerGroupsControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a partner group attached to exactly one owner (`platformId` / `federationId` / `leagueId`). Returns the created group.
 * @summary Create partner group (dashboard)
 */
export const dashboardPartnerGroupsControllerCreate = (
  dashboardCreatePartnerGroup: BodyType<DashboardCreatePartnerGroup>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPartnerGroup>(
    {
      url: `/api/dashboard/v1/partner-groups`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreatePartnerGroup,
      signal,
    },
    options
  );
};

export const getDashboardPartnerGroupsControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardPartnerGroupsControllerCreate400
    | DashboardPartnerGroupsControllerCreate401
    | DashboardPartnerGroupsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreatePartnerGroup> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPartnerGroupsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreatePartnerGroup> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerCreate>>,
    { data: BodyType<DashboardCreatePartnerGroup> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardPartnerGroupsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPartnerGroupsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPartnerGroupsControllerCreate>>
>;
export type DashboardPartnerGroupsControllerCreateMutationBody =
  BodyType<DashboardCreatePartnerGroup>;
export type DashboardPartnerGroupsControllerCreateMutationError = ErrorType<
  | DashboardPartnerGroupsControllerCreate400
  | DashboardPartnerGroupsControllerCreate401
  | DashboardPartnerGroupsControllerCreate429
>;

/**
 * @summary Create partner group (dashboard)
 */
export const useDashboardPartnerGroupsControllerCreate = <
  TError = ErrorType<
    | DashboardPartnerGroupsControllerCreate400
    | DashboardPartnerGroupsControllerCreate401
    | DashboardPartnerGroupsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreatePartnerGroup> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPartnerGroupsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreatePartnerGroup> },
  TContext
> => {
  const mutationOptions = getDashboardPartnerGroupsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Full partner-group detail with `partnersCount`. 404 when it doesn't exist or is out of the caller's scope.
 * @summary Get partner group detail (dashboard)
 */
export const dashboardPartnerGroupsControllerDetail = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardPartnerGroup>(
    { url: `/api/dashboard/v1/partner-groups/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardPartnerGroupsControllerDetailQueryKey = (id: string) => {
  return [`/api/dashboard/v1/partner-groups/${id}`] as const;
};

export const getDashboardPartnerGroupsControllerDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
  TError = ErrorType<
    | DashboardPartnerGroupsControllerDetail400
    | DashboardPartnerGroupsControllerDetail401
    | DashboardPartnerGroupsControllerDetail404
    | DashboardPartnerGroupsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardPartnerGroupsControllerDetailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>
  > = ({ signal }) => dashboardPartnerGroupsControllerDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardPartnerGroupsControllerDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>
>;
export type DashboardPartnerGroupsControllerDetailQueryError = ErrorType<
  | DashboardPartnerGroupsControllerDetail400
  | DashboardPartnerGroupsControllerDetail401
  | DashboardPartnerGroupsControllerDetail404
  | DashboardPartnerGroupsControllerDetail429
>;

export function useDashboardPartnerGroupsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
  TError = ErrorType<
    | DashboardPartnerGroupsControllerDetail400
    | DashboardPartnerGroupsControllerDetail401
    | DashboardPartnerGroupsControllerDetail404
    | DashboardPartnerGroupsControllerDetail429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPartnerGroupsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
  TError = ErrorType<
    | DashboardPartnerGroupsControllerDetail400
    | DashboardPartnerGroupsControllerDetail401
    | DashboardPartnerGroupsControllerDetail404
    | DashboardPartnerGroupsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardPartnerGroupsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
  TError = ErrorType<
    | DashboardPartnerGroupsControllerDetail400
    | DashboardPartnerGroupsControllerDetail401
    | DashboardPartnerGroupsControllerDetail404
    | DashboardPartnerGroupsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get partner group detail (dashboard)
 */

export function useDashboardPartnerGroupsControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
  TError = ErrorType<
    | DashboardPartnerGroupsControllerDetail400
    | DashboardPartnerGroupsControllerDetail401
    | DashboardPartnerGroupsControllerDetail404
    | DashboardPartnerGroupsControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardPartnerGroupsControllerDetail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardPartnerGroupsControllerDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update of `title` / `color`. The owner attachment cannot be changed here. 404 when the group is out of the caller's scope.
 * @summary Update partner group (dashboard)
 */
export const dashboardPartnerGroupsControllerUpdate = (
  id: string,
  dashboardUpdatePartnerGroup: BodyType<DashboardUpdatePartnerGroup>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardPartnerGroup>(
    {
      url: `/api/dashboard/v1/partner-groups/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdatePartnerGroup,
    },
    options
  );
};

export const getDashboardPartnerGroupsControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardPartnerGroupsControllerUpdate400
    | DashboardPartnerGroupsControllerUpdate401
    | DashboardPartnerGroupsControllerUpdate404
    | DashboardPartnerGroupsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdatePartnerGroup> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPartnerGroupsControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdatePartnerGroup> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerUpdate>>,
    { id: string; data: BodyType<DashboardUpdatePartnerGroup> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardPartnerGroupsControllerUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPartnerGroupsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPartnerGroupsControllerUpdate>>
>;
export type DashboardPartnerGroupsControllerUpdateMutationBody =
  BodyType<DashboardUpdatePartnerGroup>;
export type DashboardPartnerGroupsControllerUpdateMutationError = ErrorType<
  | DashboardPartnerGroupsControllerUpdate400
  | DashboardPartnerGroupsControllerUpdate401
  | DashboardPartnerGroupsControllerUpdate404
  | DashboardPartnerGroupsControllerUpdate429
>;

/**
 * @summary Update partner group (dashboard)
 */
export const useDashboardPartnerGroupsControllerUpdate = <
  TError = ErrorType<
    | DashboardPartnerGroupsControllerUpdate400
    | DashboardPartnerGroupsControllerUpdate401
    | DashboardPartnerGroupsControllerUpdate404
    | DashboardPartnerGroupsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdatePartnerGroup> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPartnerGroupsControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdatePartnerGroup> },
  TContext
> => {
  const mutationOptions = getDashboardPartnerGroupsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Remove a partner group. By default (`deletePartners=false`) the group is deleted and its partners are detached (they move to the main partner list). With `deletePartners=true` the group AND all its partners are deleted. 404 when it's out of the caller's scope.
 * @summary Delete partner group (dashboard)
 */
export const dashboardPartnerGroupsControllerRemove = (
  id: string,
  params?: DashboardPartnerGroupsControllerRemoveParams,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    { url: `/api/dashboard/v1/partner-groups/${id}`, method: "DELETE", params },
    options
  );
};

export const getDashboardPartnerGroupsControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardPartnerGroupsControllerRemove400
    | DashboardPartnerGroupsControllerRemove401
    | DashboardPartnerGroupsControllerRemove404
    | DashboardPartnerGroupsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerRemove>>,
    TError,
    { id: string; params?: DashboardPartnerGroupsControllerRemoveParams },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardPartnerGroupsControllerRemove>>,
  TError,
  { id: string; params?: DashboardPartnerGroupsControllerRemoveParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerRemove>>,
    { id: string; params?: DashboardPartnerGroupsControllerRemoveParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return dashboardPartnerGroupsControllerRemove(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardPartnerGroupsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardPartnerGroupsControllerRemove>>
>;

export type DashboardPartnerGroupsControllerRemoveMutationError = ErrorType<
  | DashboardPartnerGroupsControllerRemove400
  | DashboardPartnerGroupsControllerRemove401
  | DashboardPartnerGroupsControllerRemove404
  | DashboardPartnerGroupsControllerRemove429
>;

/**
 * @summary Delete partner group (dashboard)
 */
export const useDashboardPartnerGroupsControllerRemove = <
  TError = ErrorType<
    | DashboardPartnerGroupsControllerRemove400
    | DashboardPartnerGroupsControllerRemove401
    | DashboardPartnerGroupsControllerRemove404
    | DashboardPartnerGroupsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardPartnerGroupsControllerRemove>>,
    TError,
    { id: string; params?: DashboardPartnerGroupsControllerRemoveParams },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardPartnerGroupsControllerRemove>>,
  TError,
  { id: string; params?: DashboardPartnerGroupsControllerRemoveParams },
  TContext
> => {
  const mutationOptions = getDashboardPartnerGroupsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
